
import React from 'react';
import styles from './SignUpButton.module.css';
import { Link } from 'react-router-dom';

const SignUpButton = () => {
    return (
        <Link to="/signup" style={{ textDecoration: 'none' }}>
            <button className={styles.container}>
                サインアップ
            </button>
        </Link>
    );
};

export default SignUpButton;
